<template>
    <div class="tech">
        <div class="container bg-white mt-3 p-5">
            <h3 class="text-center">Technologies I used</h3>
            <img src="../../public/img/Technologies.png" alt="Technologies" width="100%">
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  color: #000;
}
.container{
     box-shadow: 8px 14px 38px rgba(39,44,49,.06), 1px 3px 8px rgba(39,44,49,.03);
}
.container:hover{
    transition: 0.5s ease-in-out;
    box-shadow: none;
}
</style>
